<template>
    <div class="class-select">
        <ul>
            <li @click="click('Y', $t('economy_cab'))">{{$t('economy_cab')}}</li>
            <li @click="click('S', $t('super_cab'))">{{$t('super_cab')}}</li>
            <li @click="click('C', $t('business_cab'))">{{$t('business_cab')}}</li>
            <li @click="click('F', $t('first_cab'))">{{$t('first_cab')}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'classSelect',
    methods: {
        click(type, name) {
            this.$emit('select', type, name);
        }
    }
}
</script>

<style lang="scss" scoped>
.class-select {
    position: absolute;
    background-color: #fff !important;
    box-shadow:0px 2px 10px 0px rgba(0,0,0,0.16),0px 2px 5px 0px rgba(0,0,0,0.26);
    min-width: 200px;
    top: 40px;

    ul {
        li {
            padding: 10px;
            font-size: 14px;
            color: #484848;
            cursor: pointer;

            &:hover {
                background-color: RGBA(0, 169, 186, 0.4);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/AirTicket/components/ClassSelect.vue